import { useRecoilCallback } from "recoil";
import { DenseOrderSheetSet } from "@/features/order-sheets/order-sheet.type";
import {
  boutiqueOrderSheetSetRowsMutateId,
  boutiqueOrderSheetSetRowsState,
} from "@/features/order-status/recoils/boutique-order-sheet-set-rows-state";
import { createBoutiqueOrderSheetSetRows } from "@/features/order-status/helpers/boutique-order-sheet-set-row-helper";
import { BoutiqueOrderSheetSetRow } from "@/features/order-status/order-sheet-set-row.type";
import { GridMapperToRowOption } from "@/features/ui/grid-row/gird-mapper";

export default function useBoutiqueOrderSheetSetRows() {
  const setRows = useRecoilCallback(
    ({ set, snapshot }) =>
      (
        orderSheetSets?: DenseOrderSheetSet[],
        option?: GridMapperToRowOption
      ) => {
        set(boutiqueOrderSheetSetRowsState, (prev) => {
          return createBoutiqueOrderSheetSetRows(
            orderSheetSets,
            prev,
            option
          ) as BoutiqueOrderSheetSetRow[];
        });
      },
    []
  );

  const mutateRows = useRecoilCallback(
    ({ set }) =>
      () => {
        set(boutiqueOrderSheetSetRowsMutateId, (prev) => {
          return prev + 1;
        });
      },
    []
  );

  return {
    setRows,
    mutateRows,
  };
}
